<template>
  <v-footer class="navigation">
    <v-sheet class="navigation-bar">
      <v-row
          align="center"
          justify="space-around"
          no-gutters>
        <v-col
            v-for="item in navigationItems"
            :key="item.label"
            cols="4"
            :class="{ 'navigation-item--active': isItemActive(item) }"
            class="navigation-item"
            role="button"
            tabindex="0"
            @click="handleNavigation(item)"
            @keydown.enter="handleNavigation(item)"
            @keydown.space.prevent="handleNavigation(item)"
        >
          <v-btn
              :class="{ 'navigation-button--active': isItemActive(item) }"
              class="navigation-button"
              icon
              variant="text"
          >
            <i :class="item.icon"/>
          </v-btn>
          <v-card-text
              :class="{ 'navigation-label--active': isItemActive(item) }"
              class="navigation-label pa-0"
          >
            {{ item.label }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-sheet>

    <ModalLogin ref="ModalLogin"/>
    <ModalAccount ref="ModalAccount"/>
  </v-footer>
</template>

<script>
import ModalLogin from '@/components/modal/Login';
import ModalAccount from '@/components/modal/Account';
import {mapGetters} from "vuex";

export default {
  name: 'AppNavigation',

  components: {
    ModalLogin,
    ModalAccount
  },

  computed: {
    ...mapGetters([
      'user'
    ]),

    isCompanyUser() {
      return this.user?.type === 'company'
    },

    isAdminUser() {
      return this.user?.isAdmin === true
    },

    publicCompanyPath() {
      const slug = this.createCompanySlug(this.user?.companyName)
      return slug ? `/${slug}` : '/company'
    },

    navigationItems() {
      if (this.isCompanyUser) {
        return [
          {
            label: 'Dashboard',
            icon: 'fa-solid fa-chart-line',
            path: '/company'
          },
          {
            label: 'Mein Unternehmen',
            icon: 'fa-solid fa-building',
            path: this.publicCompanyPath
          },
          {
            label: 'Anfragen',
            icon: 'fa-solid fa-inbox',
            path: '/anfragen'
          }
        ]
      }

      return [
        {
          label: 'Start',
          icon: 'fa-solid fa-house',
          path: '/'
        },
        {
          label: 'Preisrechner',
          icon: 'fa-solid fa-calculator',
          path: '/preisrechner'
        },
        this.isAdminUser
            ? {
              label: 'Admin',
              icon: 'fa-solid fa-user-shield',
              path: '/admin'
            }
            : this.user
            ? {
              label: 'Account',
              icon: 'fa-regular fa-circle-user',
              action: 'account'
            }
            : {
              label: 'Anmelden',
              icon: 'fa-solid fa-arrow-right-to-bracket',
              action: 'login'
            }
      ]
    }
  },

  methods: {
    handleNavigation(item) {
      if (item.action === 'login') {
        this.$refs.ModalLogin.setState(true)
        return
      }

      if (item.action === 'account') {
        this.$refs.ModalAccount.setState(true)
        return
      }

      if (item.path && this.$route.path !== item.path) {
        this.$router.push(item.path)
      }
    },

    isItemActive(item) {
      if (item.action) {
        return false
      }

      return this.$route.path === item.path
    },

    createCompanySlug(value) {
      return String(value || '')
          .toLowerCase()
          .replace(/ä/g, 'ae')
          .replace(/ö/g, 'oe')
          .replace(/ü/g, 'ue')
          .replace(/ß/g, 'ss')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]/g, '')
    }
  }
}
</script>
